import React, { useState } from 'react';
import { EventList } from '../components/EventList.tsx';
import { EventForm } from '../components/EventForm.tsx';
import { Navigation } from '../components/Navigation.tsx';
import './AdminDashboard.css';

export const AdminDashboard: React.FC = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleClose = () => {
    setShowCreateForm(false);
  };

  return (
    <div className="admin-dashboard">
      <Navigation />
      {showCreateForm && (
        <div className="modal-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) handleClose();
        }}>
          <div className="modal">
            <EventForm onSubmit={handleClose} />
            <button 
              className="button secondary" 
              onClick={handleClose}
              style={{ margin: '0 20px 20px' }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <EventList onCreateClick={() => setShowCreateForm(true)} />
    </div>
  );
};

export default AdminDashboard;
